// ISDP CUSTOM: "View source" affordance.
//
// Renders a small button linking to an entity's source repo/file (from the Backstage
// location annotations, via getSourceUrl). Available to every user who can see the
// entity — it used to be admin-only, but the source of a catalog entry is just its
// catalog-info.yaml, and knowing where an entry comes from is useful to everyone.
// Renders nothing for entities with no known http(s) source. Used on the catalog/API
// entity pages (via EntitySourceBar) and, via a TechDocs Subheader addon, in the doc
// reader — so the backing repo is one click away from any surface.
import { Entity } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { getSourceUrl } from '../catalog/entityHelpers';
import './SourceButton.css';

/** Presentational + URL gated. Pass the entity explicitly. */
export const SourceLink = ({ entity }: { entity?: Entity | null }) => {
  if (!entity) {
    return null;
  }
  const url = getSourceUrl(entity);
  if (!url) {
    return null;
  }
  return (
    <a
      className="devhub-source-link"
      href={url}
      target="_blank"
      rel="noreferrer"
      title="Open the source repo/file"
    >
      <odx-icon name="core::link-external" size="sm" />
      <span>View source</span>
    </a>
  );
};

/** Entity-page variant — reads the entity from the surrounding EntityProvider. */
export const EntitySourceButton = () => {
  const { entity } = useEntity();
  return <SourceLink entity={entity} />;
};
